<template>
  <div class="popWarp" @click="closePop()">
    <div :class="`popDetail ${$store.state.isMobile ? '' : 'pcPop'}`" @click.stop="">
      <slot></slot>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
    };
  },

  props: ['editDetaiType'],

  methods: {
    closePop() {
      if (this.editDetaiType == 'addUserInfo') return
      this.$parent.showPop = false
      this.$parent.showAddPcMember = false
      this.$parent.showShareModel = false
      this.$parent.showAdd = false
    }
  },

  created() {
  },

  computed: {
  
  }
}
</script>

<style scoped lang="scss">
  .popWarp{
    height: 100vh;
    width: 100vw;
    overflow-x: hidden;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 999;
    background-color: rgba(0,0,0,0.5);
  }
  .popDetail{
    position: fixed;
    top: 50%;
    left: 0;
    width: 8rem;
    margin: auto 0.5rem;
    min-height: 4rem;
    background-color: #fff;
    z-index: 1000;
    border-radius: 0.5rem;
    transform:translateY(-50%);
    -ms-transform::translateY(-50%);
    -moz-transform::translateY(-50%);
    -webkit-transform::translateY(-50%);
    -o-transform::translateY(-50%);
    padding: 0.5rem;
  }
  .pcPop{
    margin: auto;
    margin-left: calc(50% - 300px);
    padding: 30px;
    width: 600px;
    min-height: 400px;
    border-radius: 20px;
    // width: 9rem;
  }
</style>
